import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import md5 from 'md5';
import classnames from 'classnames';
import { toggleSidebar, toggleMeSetting } from '../actions';
import clientId from 'clientId';
import { updateUser } from 'modules/eadmin';
import moment from 'moment';
import { Button, Input, Radio, Icon, message, Row, Col } from 'antd';
const RadioGroup = Radio.Group;
const avatarUrl = require('./images/avatar.png');

const container = connect(
  state => ({
    isCollllapsed: _.get(state, 'sidebar.isCollllapsed'),
    isMeSetting: _.get(state, 'sidebar.isMeSetting'),
    me: _.get(state, 'me')
  })
)

class MeSetting extends Component {

  state = {
    language: _.get(this.props.me, 'lang') == 'hk' ? 'tw' : _.get(this.props.me, 'lang') || 'tw',
    usernameChecked: false,
    password2Checked: false,
    showSuccess: false,
    showNameIsChecked: false,
    isSamePassword: null
  }

  handlePasswordConfirmChange = (e) => {
    this.setState({
      passwordConfirm: e.target.value,
      confirmed: e.target.value === this.state.password,
    })
  }

  handleOKClick = () => {
    const username = this.refs.username.value;
    const password = this.refs.password.value;
    const { dispatch, me } = this.props;
    let lang = this.state.language;
    let isSame = this.state.isSamePassword;
    if (username && password && isSame) {
      if (clientId !== 'uminer' && lang === 'tw') {
        lang = 'hk'
      }

      let obj = {}

      if (password !== "") {
        obj = {
          groupId: me.group_id,
          userId: me.id,
          lang: lang,
          password: password,
          username: username,
          email: me.email,
        }
      } else {
        obj = {
          groupId: me.group_id,
          userId: me.id,
          lang: lang,
          username: me.username,
          email: me.email,
        }
      }
      dispatch(updateUser(obj))
        .then(() => {
          message.success(`${t('commonModify')}${t('commonSuccess')}`);
        })
    }
  }

  checkUserName = () => {
    const username = this.refs.username.value;

    this.setState({
      showNameIsChecked: true,
    });

    if (username === '') {
      this.setState({
        usernameChecked: true,
      });
      this.refs.username.focus();
    } else {
      this.setState({
        usernameChecked: false,
      });
    }
  }
  checkPasswordSame = () => {
    const password = this.refs.password.value;
    const password2 = this.refs.password2.value;
    if (password && password2) {
      if (password === password2) {
        this.setState({ isSamePassword: true });
      } else {
        this.setState({ isSamePassword: false });
      }
    }
  }

  render() {
    const { isCollllapsed, me, isMeSetting, dispatch } = this.props;
    return (
      <Row className="me-setting-panel margin-left-md">
        <Col span="7" className="setting-sidebar">
          <div className="avatar padding-top-xlg">
            <img
              src={`http://www.gravatar.com/avatar/${md5(me.email)}?d=retro`}
              ref={(avatar) => {
                if (avatar) {
                  avatar.onerror = () => {
                    avatar.src = avatarUrl
                  }
                }
              }}
            />
            <div className="margin-bottom-md setting-userName">
              <strong>{_.get(me, 'username')}</strong>
            </div>
            <div className="margin-bottom-md setting-group">
              <span>創建於 </span>
              <span>{moment(_.get(me, 'created_at')).format('YYYY-MM-DD hh:mm')}</span>
            </div>
            <div className="margin-bottom-md setting-group">
              <span>隸屬於 </span>
              <strong>{_.get(me, 'group_name')}</strong>
            </div>
          </div>
        </Col>
        <Col span="17" className="setting-data">
          <span className="margin-top-no setting-data-text">設定個人資料</span>
          <hr className="margin-bottom-md" />
          <div className="margin-bottom-md padding-top-md">
            <strong>用戶名</strong>
          </div>
          <Row className="margin-bottom-md padding-top-md">
            <Col span="17">
              <input
                type="text"
                className="form-control"
                defaultValue={_.get(me, 'username')}
                ref="username"
                onBlur={this.checkUserName} />
            </Col>
            <Col span="7">
              {this.state.usernameChecked &&
                <div className="check-error-text margin-left-md">用户名不能為空</div>
              }
              {!this.state.usernameChecked && this.state.showNameIsChecked &&
                <div className="check-success-icon"><Icon type="check-circle" /></div>
              }
            </Col>
          </Row>
          <div className="margin-bottom-md padding-top-md">
            <strong>電郵地址(登入賬號)</strong>
          </div>
          <Row className="margin-bottom-md padding-top-md">
            <Col span="17">
              <input type="text" className="form-control" value={_.get(me, 'email')} disabled />
            </Col>
          </Row>
          <div className="margin-bottom-md padding-top-md">
            <strong>新密碼</strong>
          </div>
          <Row>
            <Col span="17" className="margin-bottom-md padding-top-md">
              <input
                type="password"
                className="form-control"
                onChange={(this.checkPasswordSame)}
                onBlur={(this.checkPasswordSame)}
                ref="password"
              />
            </Col>
          </Row>
          <div className="margin-bottom-md padding-top-md">
            <strong>重複輸入密碼</strong>
          </div>
          <Row className="padding-top-md">
            <Col span="17">
              <input
                type="password"
                className="form-control"
                onChange={(this.checkPasswordSame)}
                onBlur={(this.checkPasswordSame)}
                ref="password2"
              />
            </Col>
            <Col span="7">
              {this.state.isSamePassword == false &&
                <div className="check-error-text margin-left-md">兩次輸入密碼不一致</div>
              }
              {this.state.isSamePassword == true &&
                <div className="check-success-icon"><Icon type="check-circle" /></div>
              }
            </Col>
          </Row>
          <hr className="margin-bottom-md padding-top-md" />
          <Row>
            <Col span='6'>
              <button
                className="btn btn-success"
                onClick={() => this.handleOKClick()}
              >確認修改</button>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default container(MeSetting);



/** WEBPACK FOOTER **
 ** ./src/app/modules/sidebar/components/MeSetting.js
 **/